import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';

import { useNavMenus } from '@/hooks/use-nav-menus';
import { useLocalization } from '@/hooks/use-localization';
import { useGlobalQueries } from '@/hooks/use-global-queries';

export const Login = () => {
    const { localize } = useLocalization();
    const { headerSettings } = useNavMenus();
    const { getMarketType } = useGlobalQueries();

    const menuRef = useRef<HTMLDivElement>(null);
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        const handleEscapeKey = (event: KeyboardEvent) => {
            if (event.key === 'Escape' && isActive) {
                setIsActive(false);
            }
        };

        document.addEventListener('keydown', handleEscapeKey);

        return () => {
            document.removeEventListener('keydown', handleEscapeKey);
        };
    }, [isActive]);

    if (getMarketType() === 'cluster' || !headerSettings.data?.login_choices?.length) {
        return null;
    }

    return (
        <div data-component="login">
            {isActive ? (
                <div
                    onClick={() => setIsActive(false)}
                    className="r-fixed r-left-0 r-top-0 r-h-full r-w-full r-bg-black r-opacity-10 md:r-opacity-40"
                />
            ) : null}
            <div className="r-relative">
                <button
                    className={clsx(
                        'r-rounded-3xl r-border-2 r-border-black r-px-6 r-py-1 r-text-sm r-font-bold r-text-black r-transition-all hover:r-bg-tertiary-500 hover:r-text-white focus-visible:r-bg-tertiary-500 focus-visible:r-text-white md:r-px-8 md:r-py-2 md:r-text-base',
                        {
                            isActive: 'r-bg-tertiary-500 r-text-white',
                        }
                    )}
                    onClick={() => setIsActive(!isActive)}
                >
                    {localize('log-in')}
                </button>
                {isActive ? (
                    <div
                        role="menu"
                        ref={menuRef}
                        onBlur={e => {
                            if (!e.relatedTarget || !menuRef.current?.contains(e.relatedTarget)) {
                                setIsActive(false);
                            }
                        }}
                        className="r-absolute -r-right-14 r-top-10 r-min-w-[160px] r-rounded-2xl r-bg-white md:r-right-0 md:r-top-20 md:r-min-w-[300px]"
                    >
                        {headerSettings.data.login_choices.map(
                            ({ login_link_url: link, login_link_text: text, login_link_text_mobile: mobileText }, index) => (
                                <Link
                                    className="r-flex r-items-center r-justify-between r-gap-4 r-border-b r-border-b-tertiary-500 r-px-4 r-py-3 r-text-black last:r-border-b-0 hover:r-text-tertiary-500 hover:r-underline hover:r-decoration-tertiary-500 md:r-px-5 md:r-py-6"
                                    to={link?.url || '/'}
                                    target={link?.target || '_self'}
                                    onClick={() => setIsActive(false)}
                                    key={index}
                                >
                                    <span className="r-hidden md:r-block">{text}</span>
                                    <span className="md:r-hidden">{mobileText || text}</span>
                                    <img height={15} width={15} src="/assets/icons/arrow-out-black.svg" alt="" />
                                </Link>
                            )
                        )}
                    </div>
                ) : null}
            </div>
        </div>
    );
};
